import { useState, useCallback } from 'react';

export const useDialog = (initialState = false) => {
  const [isOpen, setIsOpen] = useState(initialState);
  const [dialogData, setDialogData] = useState(null);

  const openDialog = useCallback((data = null) => {
    setDialogData(data);
    setIsOpen(true);
  }, []);

  const closeDialog = useCallback(() => {
    setIsOpen(false);
    // Сбрасываем данные немного позже, чтобы избежать мигания UI
    setTimeout(() => setDialogData(null), 200);
  }, []);

  return { isOpen, dialogData, openDialog, closeDialog };
};